import { ComponentStyleConfig } from '@chakra-ui/react';

export const OverlayDialog: ComponentStyleConfig = {
  baseStyle: {
    padding: {
      base: '80px 16px 0 16px',
      md: '32px 16px 0 16px',
      lg: '72px 24px 0',
    },
    background: 'surface1',
    height: '100%',
    position: 'relative',
    zIndex: 1300,
    overflow: 'auto',

    '.close-button': {
      color: 'iconBase',
      background: 'M.30',
      position: 'fixed',
      top: { base: 4, md: 6, lg: 12 },
      right: { base: 4, md: 6 },
      borderRadius: '100%',
      boxShadow: 'none',
      zIndex: 1,
      _focus: {
        boxShadow: 'none',
      },
      _hover: {
        transform: 'scale(1.02)',
        boxShadow: 'none !important',
        color: 'M.70',
      },
      _active: {
        transform: 'scale(0.99)',
        boxShadow: 'none',
      },
    },
  },
};
